var map = {
	"./_ASEAN.png": 76642,
	"./_African Union(OAS).png": 92828,
	"./_Arab League.png": 45497,
	"./_CARICOM.png": 20528,
	"./_CIS.png": 43985,
	"./_Commonwealth.png": 27833,
	"./_European Union.png": 96412,
	"./_Islamic Conference.png": 2023,
	"./_Kosovo.png": 68344,
	"./_NATO.png": 46631,
	"./_Northern Cyprus.png": 75878,
	"./_Northern Ireland.png": 21531,
	"./_OPEC.png": 83214,
	"./_Olimpic Movement.png": 12667,
	"./_Red Cross.png": 30654,
	"./_Somaliland.png": 4968,
	"./_United Nations.png": 60108,
	"./_england.png": 20572,
	"./_scotland.png": 22230,
	"./_wales.png": 40829,
	"./ad.png": 88346,
	"./ae.png": 31934,
	"./af.png": 48222,
	"./ag.png": 27348,
	"./ai.png": 56035,
	"./al.png": 88285,
	"./am.png": 52788,
	"./an.png": 75279,
	"./ao.png": 54201,
	"./aq.png": 75984,
	"./ar.png": 22495,
	"./as.png": 3401,
	"./at.png": 51717,
	"./au.png": 73685,
	"./aw.png": 19225,
	"./az.png": 12330,
	"./ba.png": 39043,
	"./bb.png": 5103,
	"./bd.png": 27989,
	"./be.png": 44043,
	"./bf.png": 94842,
	"./bg.png": 13047,
	"./bh.png": 67485,
	"./bi.png": 91842,
	"./bj.png": 17149,
	"./bm.png": 56503,
	"./bn.png": 45390,
	"./bo.png": 58758,
	"./br.png": 11954,
	"./bs.png": 79320,
	"./bt.png": 96587,
	"./bw.png": 5394,
	"./by.png": 13147,
	"./bz.png": 1939,
	"./ca.png": 84871,
	"./cd.png": 68541,
	"./cf.png": 32857,
	"./cg.png": 44325,
	"./ch.png": 97776,
	"./ci.png": 11883,
	"./ck.png": 13937,
	"./cl.png": 13612,
	"./cm.png": 97954,
	"./cn.png": 59262,
	"./co.png": 27906,
	"./cr.png": 28133,
	"./cu.png": 57881,
	"./cv.png": 99459,
	"./cy.png": 84168,
	"./cz.png": 34174,
	"./de.png": 1230,
	"./dj.png": 48986,
	"./dk.png": 97031,
	"./dm.png": 64273,
	"./do.png": 70147,
	"./dz.png": 90243,
	"./ec.png": 47628,
	"./ee.png": 45188,
	"./eg.png": 22121,
	"./eh.png": 25780,
	"./er.png": 86847,
	"./es.png": 94147,
	"./et.png": 3190,
	"./fi.png": 58987,
	"./fj.png": 89566,
	"./fm.png": 34737,
	"./fo.png": 47042,
	"./fr.png": 80640,
	"./ga.png": 58246,
	"./gb.png": 28890,
	"./gd.png": 83200,
	"./ge.png": 80519,
	"./gg.png": 82420,
	"./gh.png": 49414,
	"./gi.png": 10759,
	"./gl.png": 49023,
	"./gm.png": 68772,
	"./gn.png": 32034,
	"./gp.png": 77295,
	"./gq.png": 62021,
	"./gr.png": 36759,
	"./gt.png": 71312,
	"./gu.png": 19542,
	"./gw.png": 13883,
	"./gy.png": 85314,
	"./hk.png": 66773,
	"./hn.png": 57925,
	"./hr.png": 68594,
	"./ht.png": 59408,
	"./hu.png": 44117,
	"./id.png": 23456,
	"./ie.png": 71009,
	"./il.png": 50076,
	"./im.png": 34857,
	"./in.png": 78952,
	"./iq.png": 38598,
	"./ir.png": 92118,
	"./ir2.png": 69446,
	"./is.png": 94527,
	"./it.png": 94831,
	"./je.png": 23522,
	"./jm.png": 17566,
	"./jo.png": 48298,
	"./jp.png": 71504,
	"./ke.png": 59563,
	"./kg.png": 28459,
	"./kh.png": 1938,
	"./ki.png": 10863,
	"./km.png": 2766,
	"./kn.png": 99055,
	"./kp.png": 10989,
	"./kr.png": 49104,
	"./kw.png": 11019,
	"./ky.png": 1986,
	"./kz.png": 35188,
	"./la.png": 90529,
	"./lb.png": 44171,
	"./lc.png": 30636,
	"./li.png": 87894,
	"./lk.png": 25539,
	"./lr.png": 41862,
	"./ls.png": 28789,
	"./lt.png": 51181,
	"./lu.png": 50115,
	"./lv.png": 77591,
	"./ly.png": 83189,
	"./ma.png": 46473,
	"./mc.png": 88771,
	"./md.png": 43389,
	"./me.png": 10866,
	"./mg.png": 24490,
	"./mh.png": 63695,
	"./mk.png": 12409,
	"./ml.png": 99948,
	"./mm.png": 79766,
	"./mn.png": 35717,
	"./mo.png": 98739,
	"./mq.png": 8992,
	"./mr.png": 44291,
	"./ms.png": 91452,
	"./mt.png": 30476,
	"./mu.png": 2115,
	"./mv.png": 29389,
	"./mw.png": 9478,
	"./mx.png": 69910,
	"./my.png": 89231,
	"./mz.png": 50979,
	"./na.png": 93856,
	"./nc.png": 75247,
	"./ne.png": 39923,
	"./ng.png": 80714,
	"./ni.png": 69932,
	"./nl.png": 22094,
	"./no.png": 23640,
	"./np.png": 23514,
	"./nr.png": 12548,
	"./nz.png": 38980,
	"./om.png": 20389,
	"./pa.png": 73781,
	"./pe.png": 72381,
	"./pf.png": 62717,
	"./pg.png": 31319,
	"./ph.png": 25124,
	"./pk.png": 33549,
	"./pl.png": 81151,
	"./pr.png": 61535,
	"./ps.png": 80501,
	"./pt.png": 70014,
	"./pw.png": 9013,
	"./py.png": 75085,
	"./qa.png": 56516,
	"./re.png": 31816,
	"./ro.png": 94723,
	"./rs.png": 64714,
	"./ru.png": 54972,
	"./rw.png": 85864,
	"./sa.png": 45019,
	"./sb.png": 46467,
	"./sc.png": 1357,
	"./sd.png": 46438,
	"./se.png": 31780,
	"./sg.png": 55258,
	"./si.png": 67030,
	"./sk.png": 11344,
	"./sl.png": 24284,
	"./sm.png": 5396,
	"./sn.png": 14099,
	"./so.png": 97587,
	"./sr.png": 95972,
	"./st.png": 99515,
	"./sv.png": 50803,
	"./sy.png": 79750,
	"./sz.png": 74940,
	"./tc.png": 86625,
	"./td.png": 6540,
	"./tg.png": 78393,
	"./th.png": 20043,
	"./tj.png": 74421,
	"./tl.png": 3474,
	"./tm.png": 95232,
	"./tn.png": 98974,
	"./to.png": 58536,
	"./tr.png": 35704,
	"./tt.png": 35305,
	"./tv.png": 80071,
	"./tw.png": 59359,
	"./tz.png": 91352,
	"./ua.png": 85950,
	"./ug.png": 26810,
	"./us.png": 20978,
	"./uy.png": 73395,
	"./uz.png": 9515,
	"./va.png": 85573,
	"./vc.png": 83850,
	"./ve.png": 14712,
	"./vg.png": 12530,
	"./vi.png": 35917,
	"./vn.png": 37339,
	"./vu.png": 77563,
	"./ws.png": 1057,
	"./ye.png": 8564,
	"./za.png": 26711,
	"./zm.png": 30507,
	"./zw.png": 9635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42603;